import { render, staticRenderFns } from "./UpdateProjectLeadUserModal.vue?vue&type=template&id=19678be4&"
import script from "./UpdateProjectLeadUserModal.vue?vue&type=script&lang=js&"
export * from "./UpdateProjectLeadUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports